import React from 'react';
import PropTypes from 'prop-types';
import { useTooltip } from '../../hooks';

const propTypes = {
  children: PropTypes.any,
  width: PropTypes.number,
  height: PropTypes.number,
}

const BaseTooltip = ({ children, width, height }) => {
  const { mosuePosition: { top, left } } = useTooltip();

  return (
    <g id="tooltip-sankey" fill="#6c757d">
      <rect rx={0.1} ry={0.1} x={left} y={top} fill="#fff" style={{ width, height, filter: "drop-shadow(0px 0px 10px rgb(0 0 0 / 0.1)" }} />
      {children}
    </g>
  )
}

BaseTooltip.propTypes = propTypes
BaseTooltip.defaultProps = {
  separator: true,
}

export default BaseTooltip;
